'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import { staticMediaStoreBaseURL } from '@/config/common';
import { isAuthenticated } from '@/services/identity.service';
import { getPageURL, PAGE_NAME } from '@/services/partnerPortal.service';

const Header = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const isAuthenticatedUser = isAuthenticated();

  useEffect(() => {
    setIsUserLoggedIn(isAuthenticatedUser);
  }, [isAuthenticatedUser]);

  return (
    <header
      className={`relative z-20 w-[90%] mx-auto bg-white/50 rounded-lg px-3 xs:px-4 sm:px-3 lg:px-6 py-2 md:py-4 flex justify-between items-center`}
    >
      <Link
        className={`flex items-center gap-2 hover:opacity-90 transition-opacity`}
        href='/'
      >
        <div className='relative w-[75px] xs:w-[85px] sm:w-[75px] md:w-[113px]'>
          <Image
            alt='Hafla Logo'
            className='w-full h-auto aspect-[113/36]'
            height={0}
            priority
            src={`${staticMediaStoreBaseURL}/icons/hafla-transparent-icon.svg`}
            width={0}
          />
        </div>
      </Link>
      <Link
        className={`px-3 xs:px-4 sm:px-6 py-1.5 xs:py-2 sm:py-2 md:py-3 md:px-8 rounded-md text-sm xs:text-base sm:text-sm md:text-base font-semibold shadow-sm bg-brand-gradient text-white hover:opacity-90 transition-opacity whitespace-nowrap`}
        href={getPageURL({
          pageName: isUserLoggedIn
            ? PAGE_NAME.HOME.label
            : PAGE_NAME.LOGIN.label
        })}
      >
        {isUserLoggedIn ? 'Home' : 'Login'}
      </Link>
    </header>
  );
};

export default Header;
